import React, { useState } from "react";
import CustomTooltip from "../../../components/ui/Tooltip";
import toast from "../../utils/toast";
import { Check, Copy } from "lucide-react";
import { Button } from "@mui/material";
import PropTypes from "prop-types";

function CopyToClipboard({ message, id, isCopyButton = false }) {
  const [copiedMessageId, setCopiedMessageId] = useState(null);
  const messageId = id || `chat-${id}`;

  const handleCopyText = (text, messageId) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopiedMessageId(messageId);
        setTimeout(() => {
          setCopiedMessageId(null);
        }, 1000);
      })
      .catch(() => {
        toast.error("Failed to copy text");
      });
  };

  const isCopied = copiedMessageId === messageId;
  
  let iconComponent;
  if (isCopied) {
    iconComponent = isCopyButton ? (
      <Button
        className="normal-case"
        variant="contained"
        startIcon={<Check color="white" size={17} />}
      >
        Copied
      </Button>
    ) : (
      <Check color="#000000B2" size={17} />
    );
  } else {
    iconComponent = isCopyButton ? (
      <Button
        className="normal-case"
        variant="contained"
        startIcon={<Copy color="white" size={17} />}
      >
        Copy link
      </Button>
    ) : (
      <Copy color="#000000B2" size={17} />
    );
  }

  return (
    <button onClick={() => handleCopyText(message, messageId)}>
      <CustomTooltip
        data-tooltip-id={`copy-${messageId}-tooltip`}
        data-tooltip-content={isCopied ? "Copied!" : "Copy"}
        delay={0}
        show={true}
      >
        {iconComponent}
      </CustomTooltip>
    </button>
  );
}

CopyToClipboard.propTypes = {
  message: PropTypes.string.isRequired,
  id: PropTypes.string,
  isCopyButton: PropTypes.bool,
};

export default CopyToClipboard;